import {styled} from '@linaria/react';
import React from 'react';

export const SectionWrapper: React.FC<
  React.PropsWithChildren<{
    dataTestId: string;
  }>
> = ({dataTestId, children}) => {
  return (
    <StyledDescriptionList data-testid={dataTestId}>
      {children}
    </StyledDescriptionList>
  );
};

export const StyledDescriptionList = styled.dl`
  padding-bottom: 0.25rem !important;
  margin: 0;
`;
